import React, { ReactNode } from 'react';
import { useFormikContext } from 'formik';

type PleaseExplainProps = {
  children: ReactNode,
  name: string,
  value?: string,
}

const PleaseExplain = ({ children, name, value = 'True' }: PleaseExplainProps) => {
  const { values } = useFormikContext();
  
  // XXX: not wrapping in <> causes a typing error
  return (
    <React.Fragment>
      {values[name] === value ? children : null}
    </React.Fragment>
  )
}

export default PleaseExplain;
